import APIManager from "modules/common/apiManager";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { PerPage, superWiserAccess } from "helpers/system-config";
import {
  Alert,
  BarItems,
  Button,
  ButtonCommonTheme,
  CommonFilter,
  ControlLabel,
  DataWithLoader,
  DataWrapperClass,
  FormGroup,
  InsightWrapper,
  ReportPagination,
  ReportingDropdownMenu,
  Table,
  Tip,
  Wrapper,
} from "modules/theme";
import { modalType } from "../../../../../helpers/dotenv";

import { HeaderData } from "../../../../screens/reporting/styles";
import CommonManager from "../../../../../helpers/common";

var uuid = require("uuid");

const defaultColums = [
  "PhoneNumber",
  "duration",
  "hungupCause",
  "status",
  "data",
];
const commonManager = new CommonManager();

export class Report extends Component {
  constructor(props) {
    super(props);
    this.mAPI = new APIManager();
    this.moduleName = `Provider Summary`;
    this.moduleUrl = `reporting/provider-summary`;
    let selectedColumList = defaultColums;
    this.state = {
      isActive: false,
      listData: [],
      listField: [],
      configList: [],
      columes: [],
      loading: false,
      showHide: false,
      modalType: modalType,
      total: 0,
      currentPage: 1,
      perPageCount: PerPage,
      search: "",
      MasterChecked: false,
      SingleChecked: false,
      SelectedList: [],
      ary: [],
      Filters: {},
      selectedFilter: {},
      assetsUrl: "",
      user: [],
      columnList: defaultColums,
      selectedColumList: selectedColumList,
      customerColumn: {},
      showColumn: false,
      isDownload: false,
      listGroup: [],
      editData: false,
    };
    this.bindThis();
  }
  bindThis() {
    this.onPaginationChange = this.onPaginationChange.bind(this);
    this.onPerPageChooser = this.onPerPageChooser.bind(this);
    this.getData = this.getData.bind(this);
    this.getSelectedColumnNames = this.getSelectedColumnNames.bind(this);
    this.downloadReport = this.downloadReport.bind(this);
    this.open = this.open.bind(this);
  }

  componentDidMount() {
    // reportNameOuter = window.location.pathname.split("/").pop();

    let zone = commonManager.getTimeZone();
    let { startDate, endDate } = commonManager.calculateTimeRange(
      "Today",
      zone
    );
    this.setState({
      selectedValues: {
        timezone: zone,
        sendEndTime: endDate,
      },
      Filters: {
        timezone: zone,
        sendEndTime: endDate,
      },
    });
    // // new code

    const filterDurationObject = { value: "today", label: "Today" };

    let selected =
      filterDurationObject && filterDurationObject.label
        ? filterDurationObject.label
        : "";

    if (!selected) {
      this.getList(1, "", {
        selectedValues: {
          timezone: zone,
        },

        filter: {
          timezone: zone,
          // sendEndTime:endDate,
        },
      });
      return;
    }
    const {
      startDate: startDate_Dur,
      endDate: endDate_Dur,
    } = commonManager.calculateTimeRange(selected, zone);
    // let showStartEndDate = false;
    // if (selected == "Custom Date") {
    //   showStartEndDate = true;
    // }
    this.setState({
      // showStartEndDate,
      selectedValues: {
        ...this.state.selectedValues,
        startDate: startDate_Dur,
        endDate: endDate_Dur,
        sendStartTime: startDate,
        sendEndTime: endDate,
        DatesBy: selected,
      },
      Filters: {
        filter: {
          ...this.state.Filters.filter,
          timezone: zone,
        },
      },
    });

    let tData = {
      DatesBy: selected,
      endDate: endDate_Dur,
      sendEndTime: endDate,
      startDate: startDate_Dur,
      sendStartTime: startDate_Dur,
      timezone: zone,
    };
    this.getList(1, "", tData);
  }

  open() {
    if (this.state.isActive) {
      this.setState({ isActive: false });
    } else {
      this.setState({ isActive: true });
    }
  }

  getSelectedColumnNames() {
    return this.state.selectedColumList;
  }

  downloadReport(page = 1, perPage = "", filter = "") {
    var that = this;

    this.setState({ isDownload: true });

    filter = filter || {};
    perPage = perPage || this.state.perPageCount;

    let tData = {
      page_no: page,
      orderBy: "",
      order: "",
      listConfig: this.state.customerColumn || {},
      ...filter,
    };
    this.mAPI.sendPostAPI(
      `user/export/agent/provider/report`,
      tData,
      (data) => {
        this.setState({ isDownload: false });

        if (data.status === "pending") {
          Alert.success(`You can download Report from Import & Export...`);
        } else {
          this.mAPI.downloadUrl(data.fileurl);
          let a = document.createElement("a");
          a.href = data.fileurl;
          a.download = data.csvfileName;
          a.click();
        }
      },
      (error, data) => {
        this.setState({ isDownload: false });

        Alert.error("Error");
      }
    );
  }

  getData(data) {
    data = data || {};

    let selectedUser = [];
    if (data.selectedUser && data.selectedUser.length > 0) {
      data.selectedUser.map((element) => {
        if (element.value) {
          selectedUser.push(element.value);
        }
      });
    }

    let tempData = {};

    for (let item in data) {
      if (Array.isArray(data[item])) {
        tempData = {
          ...tempData,
          [item]: data[item].map((element) => element.value || element),
        };
      } else {
        tempData = {
          ...tempData,
          [item]: data[item],
        };
      }
    }

    let filter = data;
    this.setState({
      Filters: filter,
      currentPage: 1,
      isActive: false,
      selectedValues: data,
      editData: true,
    });
    this.getList(1, this.state.perPageCount, tempData);
  }

  columnProcess(columnList) {
    let result = {
      selected: [],
      total: [],
    };
    if (columnList) {
      columnList.map((column, key) => {
        key = column && column.varibleName ? column.varibleName : key;
        if (key) {
          let field = {
            name: key,
            _id: uuid.v4(),
            checked: column.isDefault === true ? true : false,
            ...column,
          };
          result.total.push(field);
          if (column.isDefault) {
            result.selected.push(key);
          }
        }
      });
    }
    return result;
  }

  getList(page = 1, perPage = "", filter = "") {
    var that = this;
    this.setState({ loading: true });

    filter = filter || {};
    perPage = perPage || this.state.perPageCount;
    let tData = {
      listConfig: this.state.customerColumn || {},
      limit: perPage,
      page_no: page,
      orderBy: "",
      order: "",
      ...filter,
    };
    this.mAPI.sendPostAPI(
      "user/agent/provider/report",
      tData,
      (data) => {
        console.log("getlist data campaignsummary: ", data);
        that.setState({ loading: false });

        if (data && data.data) {
          let result = this.columnProcess(data.columes);
          that.setState({
            assetsUrl: data.assetsUrl,
            listData: data.data,
            listField: data.columes,
            total: data.count || 0,
            SelectedList: [],
            selectedColumList: result.selected,
            columnList: result.total,
            listGroup: data.groupBy,
          });
        } else {
          that.setState({ listData: [] });
        }
      },
      (error, data) => {
        console.log("error, data campaignsummary: ", error, data);
        that.setState({ loading: false });

        Alert.error("Error");
      }
    );
  }

  onPaginationChange(page) {
    this.setState({ currentPage: page });
    this.getList(page, this.state.perPageCount, this.state.Filters);
  }

  onPerPageChooser(perPage) {
    this.setState({ currentPage: 1 });
    this.setState({ perPageCount: perPage });
    this.getList(1, perPage, this.state.Filters);
  }

  renderContent() {
    const { history } = this.props;
    return (
      <InsightWrapper>
        <HeaderData>
          <h6>Filter</h6>
          <div
            onClick={() => {
              if (this.state.isActive) {
                this.setState({ isActive: false });
              }
            }}
            className="filter-header-bar"
          >
            <span class="material-symbols-outlined">cancel</span>
          </div>
        </HeaderData>
        <CommonFilter
          filterList={[
            "renderUser",
            "renderTeam",
            "renderCampaign",
            "renderTimezones",
          ]}
          getSelectedColumnNames={this.getSelectedColumnNames}
          getData={this.getData}
          history={history}
          brands={[]}
          queryParams={this.state.Filters}
          selectedFilter={this.state.selectedFilter}
          selectedValues={this.state.selectedValues}
          setFilter={this.setFilter}
          updateFilter={this.updateFilter}
          UserList={this.state.user}
          showAgentsOnly={true}
          editData={this.state.editData}
          reportName={this.moduleName}
        />
      </InsightWrapper>
    );
  }

  renderInfoModal() {
    return (
      <Modal show={this.state.infoShowHide} className="">
        <Modal.Header
          closeButton={() => this.setState({ infoShowHide: false })}
          onClick={() =>
            this.setState({ infoShowHide: !this.state.infoShowHide })
          }
        >
          <Modal.Title>More Info</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormGroup>
            <Table whiteSpace="nowrap" bordered hover>
              <thead>
                <tr>
                  <th>Key</th>
                  <th>Value</th>
                </tr>
              </thead>
              <tbody id="ReportInfo">
                {this.state.showInfo &&
                  this.state.showInfo.map((column) => {
                    return (
                      <tr>
                        <td> {column.key} </td>
                        <td> {column.val} </td>
                      </tr>
                    );
                  })}
              </tbody>
            </Table>
          </FormGroup>
        </Modal.Body>
      </Modal>
    );
  }
  renderArrayOfObject(tObj) {
    let tD = [];
    if (tObj) {
      for (const iterator of tObj) {
        for (let [key, value] of Object.entries(iterator)) {
          tD.push({ key: key, val: value });
        }
      }
    }
    return tD;
  }

  render() {
    const { __ } = this.context;
    const breadcrumb = [
      { title: __("Reporting"), link: "/reporting" },
      { title: __("Provider Summary"), link: "/reporting/provider-summary" },
    ];

    let _this = this;
    const mainContent = (
      <div className="overFlowTheme tableFixHeadSecondary">
        <Table whiteSpace="nowrap" bordered hover>
          <thead className="tableHeaderContainerSecondary">
            <tr>
              {this.state.listField.map((column) => {
                return (
                  !(column.isDefault && column.isHidden) && (
                    <th>{column.label}</th>
                  )
                );
              })}
            </tr>
          </thead>
          <tbody id="Report">
            {_this.state.listData.map((tData) => {
              return (
                <tr>
                  {_this.state.listField.map((column) => {
                    if (column.isDefault && column.isHidden !== true) {
                      let result = tData[column.varibleName];
                      if (
                        typeof result != "string" &&
                        typeof result != "number"
                      ) {
                        if (typeof result == "object") {
                          try {
                            result = JSON.stringify(result);
                          } catch (error) {}
                        } else {
                          result = "-";
                        }
                      }

                      if (
                        column.referenceIndex &&
                        column.referenceIndex !== ""
                      ) {
                        return (
                          <td
                            style={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "186px",
                            }}
                          >
                            <Button
                              btnStyle="link"
                              onClick={() => {
                                let tD = _this.renderArrayOfObject(
                                  tData[column.referenceIndex]
                                );
                                _this.setState({
                                  infoShowHide: true,
                                  showInfo: tD,
                                });
                              }}
                            >
                              <Tip text="Show More Info">
                                <span>{result}</span>
                              </Tip>
                            </Button>
                          </td>
                        );
                      } else {
                        return (
                          <td
                            style={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "186px",
                            }}
                          >
                            <Tip text={result}>
                              <span>{result}</span>
                            </Tip>
                          </td>
                        );
                      }
                    } else {
                      return "";
                    }
                  })}
                </tr>
              );
            })}
          </tbody>
        </Table>
        {/* </Row> */}
      </div>
    );

    const actionBarRight = (
      <BarItems className="d-flex">
        <ButtonCommonTheme type="filter" filterOnClick={() => this.open()} />
        <ButtonCommonTheme
          disabled={this.state.total === 0}
          type="download"
          downloadOnClick={() => this.downloadReport(1, "", this.state.Filters)}
          downloadState={this.state.isDownload}
        />
        {/* {!superWiserAccess.includes(currentUser.role) && ( */}
      </BarItems>
    );

    return (
      <div className="heightClass">
        <DataWrapperClass>
          {this.state.isActive && this.renderContent()}

          <span
            className={this.state.isActive ? "addClass" : "removeClass"}
            onClick={() => {
              if (this.state.isActive) {
                this.setState({ isActive: false });
              }
            }}
          >
            <Wrapper
              header={<Wrapper.Header breadcrumb={breadcrumb} />}
              heading={<ControlLabel>{this.moduleName}</ControlLabel>}
              actionBar={<Wrapper.ActionBar right={actionBarRight} />}
              footer={
                <ReportPagination
                  showOnlyTotalRecords={true}
                  count={this.state.total}
                  onPaginationChange={this.onPaginationChange}
                  onPerPageChooser={this.onPerPageChooser}
                  currentPage={this.state.currentPage}
                  perPage={this.state.perPageCount}
                />
              }
              leftSidebar={<ReportingDropdownMenu />}
              showLeftSideBar={true}
              content={
                <div>
                  <DataWithLoader
                    data={mainContent}
                    loading={this.state.loading}
                    size={this.state.listData.length}
                    count={this.state.listData.length}
                    emptyText={`Sorry..! No ${this.moduleName} Found`}
                    emptyImage="/images/empty/no_report.png"
                  />
                </div>
              }
            />
          </span>
        </DataWrapperClass>
        {this.renderInfoModal()}
      </div>
    );
  }
}

Report.contextTypes = {
  __: PropTypes.func,
};

export default Report;



// WEBPACK FOOTER //
// src/modules/screens/reporting/ProviderSummary/components/Report.jsx